import { render } from "./PRetrieveUserName.vue?vue&type=template&id=2fe15b64&scoped=true"
import script from "./PRetrieveUserName.vue?vue&type=script&lang=js"
export * from "./PRetrieveUserName.vue?vue&type=script&lang=js"

import "./PRetrieveUserName.vue?vue&type=style&index=0&id=2fe15b64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe15b64"]])

export default __exports__